import styles from "rivals/styles/exports.module.scss";

export const variantFillColor = (darkMode: boolean): string => {
  return darkMode ? styles.bone : styles.abyss;
};
